import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface MenuItem {
  icon?: string;
  label: string;
  path: string;
  'data-cy'?: string;
}

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
  imports: [MatListModule, MatIconModule, MatMenuModule, MatButtonModule, MatTooltipModule]
})
export class SideMenuComponent {
  @Input({ required: true }) rootRoutes: MenuItem[] = [];
  @Input({ required: true }) organizationRoutes: MenuItem[] = [];
  @Output() menuClick = new EventEmitter<string>();

  isCollapsed = false;

  onMenuClick(path: string): void {
    this.menuClick.emit(path);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }
}
